import { ExecuteFn } from 'api';

const setAdvertiser =
  (
    { thenCb, catchCb }: { thenCb?: () => any; catchCb?: () => void },
    api?: ExecuteFn,
    args?: any,
  ) =>
    (dispatch: any) => {
      if (args?.id) {
        dispatch({
          type: 'SET_ADVERTISER',
          id: args.id,
          name: args.name,
          apiKey: args.apiKey,
        });
        thenCb?.();
      }
      else if (api) {
        api({ params: args })
          .then(async ({ data }: any) => {
            dispatch({
              type: 'SET_ADVERTISER',
              id: data.id,
              name: data.name,
              apiKey: data.apiKey,
            });
            thenCb?.();
          })
          .catch(() => {
            catchCb?.();
          });
      }
    };

const unsetAdvertiser =
  ({ thenCb }: { thenCb?: () => any }) =>
    (dispatch: any) => {
      dispatch({
        type: 'UNSET_ADVERTISER',
        advertiserId: null,
        name: null,
        apiKey: null,
      });
      thenCb?.();
    };

export { setAdvertiser, unsetAdvertiser };
